<template>
  <div id="app">
    <router-view/>
    <!--layout-footer></layout-footer-->
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    updateWindowSize() {
      this.$store.dispatch('app/setWindowWidth')
    },
  },
  created() {
    window.addEventListener(
      'resize',
      this.updateWindowSize
    )
  },
  mounted() {
    // const chatEnabled = this.$store.state.app.chatEnabled;
    // if (chatEnabled) {
    //   const script = document.createElement("script");
    //   script.src = "https://embed.tawk.to/6882160475f3b71916aeee80/1j0u2c0h6";
    //   script.async = true;
    //   script.charset = "UTF-8";
    //   script.setAttribute("crossorigin", "*");
    //   document.body.appendChild(script);
    // }
  },
}
</script>
<!-- <script>
export default {
  name: 'App',
  mounted() {
	// Variables declarations

	var $wrapper = $('.main-wrapper');
	var $pageWrapper = $('.page-wrapper');
	var $slimScrolls = $('.slimscroll');

	// Sidebar

	var Sidemenu = function() {
		this.$menuItem = $('#sidebar-menu a');
	};

	function init() {
		var $this = Sidemenu;
		$('#sidebar-menu a').on('click', function(e) {
			if($(this).parent().hasClass('submenu')) {
				e.preventDefault();
			}
			if(!$(this).hasClass('subdrop')) {
				$('ul', $(this).parents('ul:first')).slideUp(350);
				$('a', $(this).parents('ul:first')).removeClass('subdrop');
				$(this).next('ul').slideDown(350);
				$(this).addClass('subdrop');
			} else if($(this).hasClass('subdrop')) {
				$(this).removeClass('subdrop');
				$(this).next('ul').slideUp(350);
			}
		});
		$('#sidebar-menu ul li.submenu a.active').parents('li:last').children('a:first').addClass('active').trigger('click');
	}
  // Sidebar Initiate
	init();

	// Mobile menu sidebar overlay

	$('body').append('<div class="sidebar-overlay"></div>');
	$(document).on('click', '#mobile_btn', function() {
		$wrapper.toggleClass('slide-nav');
		$('.sidebar-overlay').toggleClass('opened');
		$('html').addClass('menu-opened');
		return false;
	});

	// Sidebar overlay

	$(".sidebar-overlay").on("click", function () {
		$wrapper.removeClass('slide-nav');
		$(".sidebar-overlay").removeClass("opened");
		$('html').removeClass('menu-opened');
	});


// Small Sidebar

$(document).on('click', '#toggle_btn', function() {
		if($('body').hasClass('mini-sidebar')) {
			$('body').removeClass('mini-sidebar');
			$('.subdrop + ul').slideDown();
		} else {
			$('body').addClass('mini-sidebar');
			$('.subdrop + ul').slideUp();
		}
		setTimeout(function(){
			mA.redraw();
			mL.redraw();
		}, 300);
		return false;
	});

	$(document).on('mouseover', function(e) {
		e.stopPropagation();
		if($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
			var targ = $(e.target).closest('.sidebar').length;
			if(targ) {
				$('body').addClass('expand-menu');
				$('.subdrop + ul').slideDown();
			} else {
				$('body').removeClass('expand-menu');
				$('.subdrop + ul').slideUp();
			}
			return false;
		}

		$(window).scroll(function() {
			if ($(window).scrollTop() >= 30) {
				$('.header').addClass('fixed-header');
			} else {
				$('.header').removeClass('fixed-header');
			}
		});

		$(document).on('click', '#loginSubmit', function() {
			$("#adminSignIn").submit();
		});

	});
  }
}
</script> -->



// WEBPACK FOOTER //
// src/App.vue